import AcademicSuccessIcon from './component.jsx'
export default AcademicSuccessIcon
